import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
} from '@twistopayments/design-system/styles'

export const container = (theme: Theme) => css`
  & h1 {
    font-size: ${pxToRem(36)};
    line-height: 1.15;
    margin-top: 0;
  }

  h2 {
    font-size: ${pxToRem(36)};
    font-weight: 700;
    line-height: 1.3;
    margin: 0 0 ${size[24]};
  }

  h3 {
    font-size: ${pxToRem(32)};
    font-weight: 500;
  }

  & p {
    color: ${theme.palette.text.body};
    font-size: ${pxToRem(21)};
    line-height: ${pxToRem(30)};
  }

  & strong {
    font-weight: 600;
  }

  li {
    padding-left: 1em;
    text-indent: -1em;
  }

  ol {
    list-style: none;
    margin: 0;
    padding: 0;
    font-variant-numeric: tabular-nums;
  }

  ol {
    counter-reset: item var(--start, 0);
    padding-left: 1.5em;
  }

  ol > li {
    counter-increment: item;
    margin: 0.25em 0;
    text-align: left;
  }

  ol > li::before {
    content: counters(item, '.') '. ';
  }

  ul {
    list-style: disc;
  }

  ul ul {
    list-style: circle;
  }

  ul ul ul {
    list-style: square;
  }

  & a {
    border-radius: ${theme.borderRadius.md};
    padding: ${size[18]} ${size[40]};
  }

  ${breakpoint.up('sm')} {
    & h1 {
      font-size: ${pxToRem(56)};
    }

    & h2 {
      font-size: ${pxToRem(48)};
      letter-spacing: -1px;
      margin-bottom: ${size[48]};
    }

    & h3 {
      font-size: ${fontSize.xl};
    }

    /* & ul {
      margin-top: ${size[24]};
      margin-bottom: ${size[60]};
    } */

    & li {
      gap: ${size[20]};
    }
  }
`
